import { Box, CircularProgress, Grid, IconButton, TextField, Typography } from '@material-ui/core';
import { HeaderParameters } from '../components';
import { MailerApi } from 'services';
import { toastMessages } from 'config/constants';
import { FieldArray, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import { useProvider } from 'contexts/ProviderContext';
import * as Yup from 'yup';
import DefaultButton from 'components/DefaultButton';
import people from '_assets/parameters/people.svg';
import routes from 'config/routes';
import toast from 'react-hot-toast';
import useStyles from './styles';
import addIcon from '_assets/parameters/upload.svg';

const validationSchema = Yup.object().shape({
  invite: Yup.array()
    .of(
      Yup.object()
        .shape({
          email: Yup.string().email('Veuillez saisir une adresse mail valide.'),
        })
        .nullable(),
    )
    .min(1, 'Au moins une addresse email conforme doit être rentrée.'),
});

const Invite = () => {
  const classes = useStyles();
  const history = useHistory();
  const { provider } = useProvider();

  return (
    <Grid className={classes.root} container justifyContent="center" spacing={3}>
      <HeaderParameters image={people} noMargin text="Inviter des amis" />

      <Grid container item justifyContent="center" style={{ flexGrow: 0 }}>
        <Grid container item xs={12} md={8}>
          <Typography align="center" variant="h2">
            Maïa vous plait ! Faites le savoir et invitez vos amis à utiliser la plateforme.
          </Typography>
        </Grid>
      </Grid>

      <Formik
        onSubmit={async (values, formikHelpers) => {
          const body = {
            mail: values.invite,
            firstName: provider.first_name,
            lastName: provider.last_name,
          };

          try {
            await MailerApi.inviteFriend(body);

            formikHelpers.resetForm();
            toast.success(toastMessages.success.SEND_INVITATION);
            history.push(routes.parameters.root);
          } catch (e) {
            toast.error(toastMessages.error.SEND_INVITATION);
          }
        }}
        initialValues={{ invite: [{ email: '' }] }}
        validationSchema={validationSchema}
      >
        {({ values, handleSubmit, touched, errors, handleChange, isSubmitting }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Grid container item justifyContent="center" style={{ flexGrow: 1 }}>
                <Grid container item xs={12} justifyContent="center" style={{ height: '100%' }}>
                  <Grid
                    container
                    item
                    xs={12}
                    md={10}
                    alignItems="center"
                    justifyContent="center"
                    direction="column"
                    style={{ flexGrow: 1 }}
                  >
                    <Grid container item xs={12}>
                      <FieldArray
                        name="invite"
                        render={(arrayHelpers) =>
                          values.invite.map((email, index) => (
                            <>
                              <Box key={index} className={classes.field}>
                                <TextField
                                  style={{ margin: 8 }}
                                  label="Adresse mail"
                                  name={`invite[${index}].email`}
                                  fullWidth
                                  variant="outlined"
                                  value={values[`invite[${index}].email`]}
                                  onChange={handleChange}
                                  error={
                                    !!touched.invite &&
                                    Boolean(touched.invite[index]?.email) &&
                                    !!errors.invite &&
                                    Boolean(errors.invite[index]?.email)
                                  }
                                  helperText={
                                    !!touched.invite &&
                                    Boolean(touched.invite[index]?.email) &&
                                    !!errors.invite &&
                                    errors.invite[index]?.email
                                  }
                                />
                                <div className={classes.buttonContainer}>
                                  <IconButton
                                    style={{ height: 'fit-content', width: 'fit-content' }}
                                    onClick={() => arrayHelpers.push(' ')}
                                  >
                                    <img src={addIcon} alt="Ajout d'un champs email" />
                                  </IconButton>
                                </div>
                              </Box>
                            </>
                          ))
                        }
                      />
                    </Grid>
                  </Grid>

                  <Grid container item xs={12} justifyContent="center">
                    <Grid
                      container
                      item
                      xs={12}
                      alignItems="flex-end"
                      justifyContent="center"
                      style={{ marginBottom: 16 }}
                    >
                      {values.invite.some((value) => {
                        return value.email?.length > 0;
                      }) && (
                        <>
                          <DefaultButton
                            cancel
                            onClick={() => {
                              if (isSubmitting) return;
                              history.push(routes.parameters.root);
                            }}
                          >
                            Annuler
                          </DefaultButton>
                          <DefaultButton color="secondary" disabled={isSubmitting} variant="contained" type="submit">
                            {isSubmitting ? <CircularProgress size={20} /> : 'Valider'}
                          </DefaultButton>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          );
        }}
      </Formik>
    </Grid>
  );
};

export default Invite;
